import React, { useState } from "react";
import { Modal, Button } from "antd";
import { CloseOutlined } from "@ant-design/icons";

const DeleteAddressModal = ({ open, onClose, address, onDelete }) => {
  return (
    <Modal
      open={open}
      footer={null}
      closable={false}
      centered
      width={595}
      className="delete-modal"
    >
      <div className="delete-modal-header">
        <Button
          type="text"
          icon={<CloseOutlined />}
          onClick={onClose}
          className="close-btn"
        />
      </div>

      <div className="track-modal-header">
        <h6>Do you really want to delete this address?</h6>
        <p>{address}</p>
      </div>

      <div className="delete-modal-actions">
        <Button className="border-button" onClick={onClose}>
          Keep it
        </Button>
        <Button className="fill-button-smal" onClick={onDelete}>
          Delete
        </Button>
      </div>
    </Modal>
  );
};
 
export default DeleteAddressModal;